import { Moment } from "moment";
import Utils from "../utils";
import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";
import { AddPurchaseOrderDataModel } from "./webshop.model";


// Requests
export class InHouseDataModel {
  public table_no: string;
  public group_name: string;
  public group_code: string;
  public user_token: string;
  public place_no: number;
  public auth_token: string;
  public walleeTransactionId: string;
}

export class CheckoutPaymentMethods {
  public locale: string;
  public device: string;
  public channel: string;
  public order: AddPurchaseOrderDataModel;
  public ih_data: InHouseDataModel;
  public with_dropin_config: boolean;
}

export class CheckoutHasPayment {
  public location: number;
  public order_type: number;
}

export class CheckoutOriginKey {
  public origin: string;
}

export class CheckoutApplePaymentSession {
  public location: number; // = hypcusnr
  public validation_url: string;
}

export class CheckoutPayment {
  public type: string;
  public locale: string;
  public device: string;
  public channel: string;
  public order: AddPurchaseOrderDataModel;
  public ih_data: InHouseDataModel;
  public data_json: string;
  public return_url: string;
  public return_url_params: string;
}

export class CheckoutPaymentDetails {
  public location: number; // = hypcusnr
  public order_id: string;
  public ih_data: InHouseDataModel;
  public details_json: string;
}

export class GetStoredCheckoutPaymentModel {
  public token: string;
  public order_id: string; // wird geprüft, wenn mitgegeben, sonst "" (keine prüfung)
}

export class DisableStroredPaymentMethod {
  public location: number; // = hypcusnr
  public method_id: string;
}

// Responses
export class CheckoutPaymentMethodsModel implements ApiResponseData {
  public location: number; // = hypcusnr
  public payments: string[];
  public splitPaymentMethods: boolean;
  public json: string;
  public config_json: string;

  public DeserializeType(): void {
    // has no complex type
  }

  // todo eventuell parser überall einbauen?
  private _paymentMethods: any = null;
  public get PaymentMethods(): any {
    if (this._paymentMethods === null && this.json !== null)
      this._paymentMethods = JSON.parse(this.json);
    return this._paymentMethods;
  }

  private _paymentMethodsConfig: any = null;
  public get PaymentMethodsConfig(): any {
    if (this._paymentMethodsConfig == null && this.config_json != null)
      this._paymentMethodsConfig = JSON.parse(this.config_json);
    return this._paymentMethodsConfig;
  }
}

export class CheckoutHasPaymentModel implements ApiResponseData {
  public location: number;
  public has_payment: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}

/**
 * Status der bestellung
 * Authorised is success, allother fail
 * Received ist noch unbekannt
 */
export enum ResponseCode_Done {
  /// <summary>
  /// The payment has been successfully authenticated with 3D Secure 2.
  /// Returned for 3D Secure 2 authentication-only transactions.
  /// </summary>
  AuthenticationFinished = "AuthenticationFinished",
  /// <summary>
  /// The payment was successfully authorised. This state serves as an
  /// indicator to proceed with the delivery of goods and services. This
  /// is a final state.
  /// </summary>
  Authorised = "Authorised",
  /// <summary>
  /// Indicates the payment has been cancelled (either by the shopper or
  /// the merchant) before processing was completed. This is a final state.
  /// </summary>
  Cancelled = "Cancelled",
  /// <summary>
  /// The issuer requires further shopper interaction before the payment
  /// can be authenticated. Returned for 3D Secure 2 transactions.
  /// </summary>
  ChallengeShopper = "ChallengeShopper",
  /// <summary>
  /// There was an error when the payment was being processed. The reason
  /// is given in the refusalReason field. This is a final state.
  /// </summary>
  Error = "Error",
  /// <summary>
  /// The issuer requires the shopper's device fingerprint before the
  /// payment can be authenticated. Returned for 3D Secure 2 transactions.
  /// </summary>
  IdentifyShopper = "IdentifyShopper",
  /// <summary>
  /// Indicates that it is not possible to obtain the final status of the
  /// payment. This can happen if the systems providing final status
  /// information for the payment are unavailable, or if the shopper needs
  /// to take further action to complete the payment. For more information,
  /// refer to Result codes.
  /// </summary>
  Pending = "Pending",
  /// <summary>
  /// Indicates that the response contains additional information that you
  /// need to present to a shopper, so that they can use it to complete a
  /// payment.
  /// </summary>
  PresentToShopper = "PresentToShopper",
  /// <summary>
  /// Indicates the payment has successfully been received by Adyen, and
  /// will be processed. This is the initial state for all payments.
  /// </summary>
  Received = "Received",
  /// <summary>
  /// Indicates the shopper should be redirected to an external web page or
  /// app to complete the authorisation.
  /// </summary>
  RedirectShopper = "RedirectShopper",
  /// <summary>
  /// Indicates the payment was refused. The reason is given in the
  /// refusalReason field. This is a final state.
  /// </summary>
  Refused = "Refused"
}

/** representation von CheckoutPaymentModel.nocoo */
export class NoCOOData {
  /** default NoCOO Url, wenn gewünschte Sprache nicht bekannt */
  public url: string;
  /** NoCOO Code */
  public code: string;
  /** NoCOO PIN */
  public pin: string;
}

export class CheckoutPaymentModel implements ApiResponseData {
  public action_json: string;
  /** enum ResponseCode_Done */
  public done: string;
  /** Ist eine ImHausBestellung */
  public ih: boolean;
  /** OrderID oder NoCOOCode-NoCOOPin */
  public order_id: string;
  /** OrderToken aus der OrderID, bei NoCOOCode leer */
  public order_token: string;
  /** Neu generierte Artikel wie Webgutscheine oder Tickets */
  public items: CompletePurchaseOrderItemModel[];
  /** use BonuspointsVersion and BonuspointsForParsing */
  public bonuspoints: string;
  /** use NoCOOData */
  public nocoo: string;
  /** Superheldenname */
  public table_name: string;
  /** Ist eine Remote Gruppenbestellung */
  public is_remote_group_order: boolean;
  /** Bruttobetrag der Bestellung in Cent */
  public order_amount: number;
  /** Gruppenname Lieferung/Abholung */
  public groupName: string;

  /**
   * use parseNewBonusPointsFromBonusPointString for get data
   */
  public get BonuspointsVersion(): number {
    if (this.bonuspoints != null) {
      const version = this.bonuspoints.substr(0, this.bonuspoints.indexOf("|"));
      if (version.startsWith("version="))
        return parseInt(version.substr(version.indexOf("=") + 1)); // +1 to skip '='
      else
        return 0;
    }
    else
      return 0;
  }

  /**
   * use parseNewBonusPointsFromBonusPointString for get data
   */
  public get BonuspointsForParsing(): string {
    if (this.bonuspoints != null)
      return this.bonuspoints.substr(this.bonuspoints.indexOf("|") + 1); // +1 to skip '|'
    else
      return "";
  }

  /**
   * wandelt nocoo string zu NoCOOData, sonst null
   */
  public get NoCOOData(): NoCOOData {
    if (!Utils.IsNullOrEmpty(this.nocoo)) {
      // nocoo = url + '|' + code + '|' + pin
      const parts = this.nocoo.split('|');
      const data = new NoCOOData();
      data.url = parts[0];
      data.code = parts[1];
      data.pin = parts[2];
      return data;
    } else {
      return null;
    }
  }

  /**
   * Gibt die NoCOODaten als URL zurück in der die PIN nicht eingegeben werden braucht
   */
  public get NoCOOUrlWithPin(): string {
    const nocooData = this.NoCOOData;
    if (nocooData) {
      let url = nocooData.url;
      if (Utils.IsNullOrEmpty(url))
        url = "https://nocoo.de"; // fallback
      return url + "/" + nocooData.code + "?pin=" + nocooData.pin;
    } else {
      return null;
    }
  }

  public DeserializeType(): void {
    const me = this;
    // not convertet for performance, because CompletePurchaseOrderItemModel is simple type
    //if (Array.isArray(me.items)) {
    //  const items = me.items;
    //  for (let i = 0; i < items.length; ++i) {
    //    const item = items[i];
    //    if (Object.getPrototypeOf(item) !== CompletePurchaseOrderItemModel) {
    //      items[i] = Utils.GetExtend(new CompletePurchaseOrderItemModel(), item);
    //    }
    //  }
    //}
  }
}

export class CompletePurchaseOrderItemModel {
  /** Position in der Bestellung */
  public position: number; // unique
  /** Webgutschein Bezeichnung DE */
  public webvouchername_de: string;
  /** Webgutschein Bezeichnung EN */
  public webvouchername_en: string;
  /** Webgutscheine nummern separiert nach Komma (,) */
  public webvouchernumbers: string;
  /** Webgutschein WalletReferenceIds */
  public webvoucherwalletreferences: string;
  /** Webgutscheine versandart (0=download, 1=post) */
  public webvoucherdelivery: number;
  /** Webgutscheine Anzeigen der Personenanzahl */
  public webvouchershowpersoncount: boolean;
  /** Webgutscheine Personenanzahl */
  public webvoucherpersoncount: number;
  /** Ticket nummern separiert nach Komma (,) */
  public ticketnumbers: string;
  /** Ticket WalletReferenceIds */
  public ticketwalletreferences: string;
  /** Aktivität des addToWallet */
  public walletactive: boolean;
}

export class DisableStroredPaymentMethodModel implements ApiResponseData {
  public success: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}
export class GenerateOriginKeyModel implements ApiResponseData {
  public origin_key: string;
  public client_key: string;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class GetPublicKeyModel implements ApiResponseData {
  public public_key: string;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class CheckoutApplePaymentSessionModel implements ApiResponseData {
  public session_json: string;

  public DeserializeType(): void {
    // has no complex type
  }
}
